<template>
  <div class="page-main draft-box">
    <div>
      <SearchTop moduleTitle="VGM" @search="search"></SearchTop>
      <div class="page-table">
        <div>

          <WTable :WTableOpts="WTableOpts" @selection-change="handleSelectionChange">
            <template #portCode="{ row }">
              <span>{{ row.portCode }}
                <i style="font-size: 13px; color: #999; font-style: normal">({{
                        portCodes[row.portCode]
                      }})</i></span>
            </template>
            <template #containers="{ row }">
              <div>
                <div v-for="(item, index) in row.vgmListContainers" :key="item.id">
                  <p style="height: 40px; line-height: 40px" :style="{
                        borderTop: index > 0 ? '1px solid #EBEEF5' : '',
                      }">
                    {{ item.containerNo }}
                  </p>
                </div>
              </div>
            </template>
            <template #vgmWeight="{ row }">
              <div>
                <div v-for="(item, index) in row.vgmListContainers" :key="item.id">
                  <p style="height: 40px; line-height: 40px;text-align: center" :style="{
                        borderTop: index > 0 ? '1px solid #EBEEF5' : '',
                      }">
                    {{ item.vgmWeight }}
                  </p>
                </div>
              </div>
            </template>
            <template #sentStatus="{ row }">
              <div v-for="(item, index) in row.vgmListContainers" :key="item.id">
                <div style="height: 40px; line-height: 40px; padding: 0 10px" :style="{
                                        borderTop: index > 0 ? '1px solid #EBEEF5' : ''
                                    }">
                  <span v-if="item.replyStatus === 'WAITING'" style="color: #ed6a0c">发送中</span>
                  <span v-if="item.replyStatus === 'SEND_SUCCESS'" style="color: #2da641">发送成功</span>
                  <span v-if="item.replyStatus === 'REPLY_SUCCESS'" style="color: #2da641">回执成功</span>
                  <el-popover v-if="
                                            item.replyStatus === 'SEND_FAILURE' || item.replyStatus === 'REPLY_FAILURE'
                                        " placement="top" title="" width="270" trigger="hover" :content="item.replyFailureReason" style="font-size: 14px">
                    <div slot="reference">
                      <span v-if="item.replyStatus === 'SEND_FAILURE'" style="color: #d40000">发送失败</span>
                      <span v-if="item.replyStatus === 'REPLY_FAILURE'" style="color: #d40000">回执失败</span>
                      <span class="el-icon-question" style="color: #62a1f2; padding-left: 8px; font-size: 14px"></span>
                    </div>
                  </el-popover>
                </div>
              </div>
            </template>
            <template #userRemark="{ row }">
              <div>
                <span @click="updateNotes(row)" style="color:#1170EB;cursor: pointer">{{row.userRemark || '添加备注'}}</span>
              </div>
            </template>
            <template #operation="{ row }">
              <div class="table-btn">
                <el-link type="primary" @click="copyDraft(row)" :underline="false">复制
                </el-link>
                <el-link type="primary" @click="seeDraft(row)" :underline="false">查看
                </el-link>

              </div>
            </template>
          </WTable>
          <Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :pageNum="pageNum" :pageSize="pageSize" :total="total"></Pagination>
        </div>
        <RemarksPopup :delDialogVisible="delDialogVisible" @closedelDialog="closedelDialog" @confirmTheChanges="confirmTheChanges"></RemarksPopup>

        <!-- 发送-费用确认提示 -->
        <!--        <SendFeeTip v-if="sendFeeTipVisible" :visible="sendFeeTipVisible" :feeData="feeData" @closeDialog="closeFee" @sendSuccess="sendSuccess" />-->
        <!--        <FirstEmpty v-if="firstUseType" @exportCps="exportCps" @addCps="addCps" />-->
        <!--        <WUploadDialog ref="refWUploadDialog" title="导入VGM" product="CPS" :fileTemplate="fileTemplate" :action="action" :headers="{ token: token }" :on-success="handleSuccess" :on-error="handleError" :setupTxtArr="['第二步：填入下载的VGM模版信息，按模版内容格式填写', '第三步：上传已填写完整的模版']" />-->

      </div>
    </div>

  </div>
</template>
<script>

import SearchTop from "../../searchHead/Search";
import Pagination from "@/components/pagination/index.vue";
// import FirstEmpty from '@/components/FirstEmpty'
// import SendFeeTip from '../component/SendFeeTip'
import {getDraftBoxList, updateNotes} from "@/api/vgmBusiness";
import {portCodes} from "@/utils/enum";
import RemarksPopup from "@/views/new_vgm/component/remarksPopup";

export default {
  components: {
    SearchTop,
    Pagination,
    RemarksPopup
    // FirstEmpty,
    // SendFeeTip
  },
  data() {
    return {
      portCodes,
      chooseList: [], // 选中数据
      validList: [],

      WTableOpts: {
        data: [],
        tableAttrs: {},
        tableColAttrs: [
          {label: "起运港", slotName: 'portCode', width: '120px'},
          {prop: "billNo", label: "提单号", width: '180px'},
          {label: "箱号", slotName: 'containers', width: '160px'},
          {label: "VGM重量(KGS)", slotName: 'vgmWeight', width: '140px'},
          {slotName: 'sentStatus', label: '发送状态', width: '140px'},
          {
            prop: "carrierName",
            label: "船公司",
          },
          {
              prop: 'userNickName',
              label: '提交人'
          },
          {
              prop: 'sendTime',
              label: '发送日期',
              width: '110px'
          },
          {slotName: "userRemark", label: "客户备注",minWidth:'120px'},
          {prop: '', label: '操作', width: '110px', slotName: 'operation', fixed: "right"}
        ],
      },
      total:0,
      pageSize:10,
      pageNum:1,
      delDialogVisible:false,
      id:""
    }
  },
  created() {

  },
  mounted() {
    // this.getDraftBoxList()

  },
  computed: {

    // 删除 按钮状态
    disabledType() {
      return this.chooseList.length > 0 ? false : true
    },
    // 待发送 按钮状态
    unSendDisabledType() {
      return this.validList.every(o => o == true) && this.chooseList.length > 0 ? false : true
    },
  },
  methods: {
    updateNotes(row){
      this.id=row.id
      this.delDialogVisible=true
    },
    closedelDialog(){
      this.delDialogVisible=false
    },
    confirmTheChanges(remark){
      updateNotes({remark,ids:[this.id]}).then(res=>{
        this.delDialogVisible=false
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.getDraftBoxList()
      })
    },
    //复制按钮
    copyDraft(row) {

      this.$router.push({
        name: "vgmDetails",
        query: {
          vgmId:row.id,
          type:'copy',
          from:"hasBeenSent"
        }
      })
    },
    //查看按钮
    seeDraft(row){
      this.$router.push({
        name: "vgmDetails",
        query: {
          vgmId:row.id,
          type:'see',
          from:"hasBeenSent"
        }
      })
    },
    //列表
    getDraftBoxList() {
      const obj = {
        ...this.searchData,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        vgmType: 'SENT'
      }
      getDraftBoxList(obj).then(res => {

        this.WTableOpts.data = res.records
        this.total = res.total
      })
    },
    // 切换条数
    handleSizeChange({pageSize}) {
      this.pageSize = pageSize
      this.getDraftBoxList()
    },
    // 切换页码
    handleCurrentChange({pageNum}) {

      this.pageNum = pageNum
      this.getDraftBoxList()

    },
    // 价格弹窗
    closeFee() {
      this.sendFeeTipVisible = false
    },
    // 发送成功
    sendSuccess(data) {
      this.$message({
        message: '发送成功',
        type: 'success'
      })
    },
    // 发送
    moveSent() {
      // drafts.moveSent(this.chooseList).then(res => {
      // this.$message({
      //   message: '操作成功',
      //   type: 'success'
      // })
      //   this.getList()
      // })
    },
    // 删除
    deleteMsg() {
      this.$confirm('确定要删除当前数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // drafts.deleteData(this.chooseList).then(res => {
        // this.$message({
        //   message: '删除成功',
        //   type: 'success'
        // })
        //   this.getList()
        // })
      })
    },
    // 导入成功
    handleSuccess(response, file, fileList) {
      console.warn(response, file, fileList)
      this.$refs.refWUploadDialog.close()

    },
    handleError(err, file, fileList) {
      console.log(err.message)
      console.warn(err, file, fileList)
    },
    // table 选择
    handleSelectionChange(e) {
      console.log(e)
      this.chooseList = []
      this.validList = []
      this.chooseList = e.map(o => o.id)
      this.validList = e.map(o => o.valid)

    },
    // 导入舱单
    async exportCps() {
      let flag = await this.$refs.refWUploadDialog.open()
      console.warn(flag)
    },
    //新增vgm
    addCps() {
      this.$router.push({
        name: "vgmDetails"
      })
    },
    search(val) {
      console.log(val)
      this.searchData = val
      this.pageNum = 1
      this.getDraftBoxList()
    }
  },
}
</script>
<style lang="less" scoped>
.draft-box {
  .btn-div {
    margin-bottom: 24px;
  }
}
</style>